import React, { useEffect, useState } from "react";
import { Box, Typography, Button } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { getActingAsClient, clearActingAsClient } from "src/utils/actingAs";

/**
 * Persistent banner shown across the regular app (DashboardLayout) whenever an accountant is
 * acting as a client with FULL access - every wallet-service and aggregator-service API call
 * during this time transparently targets the client's data (see getActingAsHeader and each
 * service's own AccountantActingAsInterceptor), so this banner exists purely so it's never
 * ambiguous whose account is on screen, and gives an obvious, always-visible way out.
 */
const ActingAsBanner = () => {
  const history = useHistory();
  const [actingAs, setActingAs] = useState(getActingAsClient());

  // Re-check on route changes - entering/exiting acting-as mode navigates within this same
  // layout, so a plain mount-only check would miss it.
  useEffect(() => {
    const unlisten = history.listen(() => setActingAs(getActingAsClient()));
    return unlisten;
  }, [history]);

  if (!actingAs?.clientUserId) {
    return null;
  }

  const handleExit = () => {
    clearActingAsClient();
    setActingAs(null);
    history.push("/secure/accountant");
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      style={{
        background: "linear-gradient(266.46deg, #5F51DE 0%, #AD5DD3 100%)",
        color: "#fff",
        padding: "10px 16px",
        gap: 16,
        flexWrap: "wrap",
      }}
    >
      <Typography variant="body2" style={{ fontWeight: 600 }}>
        Managing {actingAs.clientEmail}'s account as their accountant
      </Typography>
      <Button
        size="small"
        variant="outlined"
        onClick={handleExit}
        style={{ textTransform: "none", color: "#fff", borderColor: "#fff", backgroundColor: "transparent" }}
      >
        Exit
      </Button>
    </Box>
  );
};

export default ActingAsBanner;
